type ChipColor = 'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning';

export const DEMO_CHARACTERS: Array<{ value: string; label: string; description: string; color: ChipColor }> = [
  { 
    value: 'therapist', 
    label: 'Dr. Sarah Johnson', 
    description: 'Licensed Therapist — AI notes, scheduling, and billing',
    color: 'primary'
  },
  { 
    value: 'admin', 
    label: 'Sarah Admin', 
    description: 'Practice Admin + Provider — dashboard, management tools, and yoga clients',
    color: 'error'
  },
  { 
    value: 'admin_provider', 
    label: 'Dr. Amanda Torres', 
    description: 'Admin + Provider — admin who also sees their own clients',
    color: 'error'
  },
  { 
    value: 'clinical_director', 
    label: 'Dr. Patricia Wells', 
    description: 'Clinical Director — oversees clinical operations and providers',
    color: 'warning'
  },
  { 
    value: 'student_therapist', 
    label: 'Michael Chen', 
    description: 'Supervised Provider — supervised workflows and co-signing',
    color: 'info'
  },
  { 
    value: 'supervisor', 
    label: 'Jessica Martinez', 
    description: 'Clinical Supervisor — reviews notes and oversees trainees',
    color: 'warning'
  },
  { 
    value: 'psychiatric_np', 
    label: 'Robert Kim', 
    description: 'Psychiatric NP — medication management workflows',
    color: 'success'
  },
  { 
    value: 'medical_assistant', 
    label: 'Autumn Breeze', 
    description: 'Medical Assistant — direct services under NP supervision',
    color: 'info'
  },
  { 
    value: 'client', 
    label: 'John Smith', 
    description: 'Individual Client — see what your clients experience',
    color: 'default'
  },
  { 
    value: 'parent_of_client', 
    label: 'Lisa Johnson', 
    description: 'Parent of Client — managing child\'s therapy',
    color: 'secondary'
  },
  { 
    value: 'part_of_couple', 
    label: 'Jane Smith', 
    description: 'Part of Couple — couple therapy with shared access',
    color: 'default'
  }
];

export const routeForRole = (role) => {
  if (!role) return '/client';
  if (role === 'admin') return '/admin';
  if (['client', 'parent_of_client', 'part_of_couple'].includes(role)) return '/client';
  return '/dashboard';
};
